<mat-drawer-container class="sidenav-container" autosize>
  <mat-drawer [opened]="opened()" [mode]="sidebarType()" [class]="`mat-elevation-z3 drawer-${color}`" [style.width.px]="sidenavDim()">
   <!---->
    <div class="sidenave-header">
      <img [style.width.px]="profilDim()" [style.height.px]="profilDim()" [src]="authUser.user.gender=='feminin'?'avatar/av1.png':'avatar/av2.png'" alt="">
      <div class="header-text" [hidden]="!showUsername()?'hide-header-text':''">
        <h2 >{{ authUser.user.name | uppercase }}</h2>
        <p>{{ authUser.user.profil.name | uppercase }}</p>
      </div>
    </div>
    <!---->
    <mat-nav-list id="sidebarList">
      @for (item of menuItems(); track $index) {
        @if (checkRights(item.right)) {
          <a mat-list-item
          [class]="open()?'menu-item':''"
          [routerLink]="item.route"
          #rla = "routerLinkActive"
          routerLinkActive="select-menu-item"
          [activated]="rla.isActive"
          [matTooltip]="open()?'':item.label"
          matTooltipPosition="right"
          (click)="openSubMenu($index)"
           [matMenuTriggerFor]="(!open() && item.submenu)?menu:null"
         >
          <mat-icon  matListItemIcon [class]="rla.isActive?'':'icon-no-fill'">{{ item.icon }}</mat-icon>
          <span matListItemTitle>{{ item.label }}</span>
        </a>

         @if (item.submenu) {
           <div class="subMenu"
            *ngIf="$index == currentSubMenuIndex() && open()"
            animate.enter="animate__animated animate__fadeInDown animate__delay-0.5s"
            animate.leave=""
            >
              <mat-nav-list class="subItemMenu" id="sidebarSubList">
                @for (sub of item.submenu; track $index) {
                  <a
                  mat-list-item
                  [routerLink]="sub.route"
                  routerLinkActive="select-menu-item"
                  [hidden]="!checkRights([sub.right!])"
                  >
                  <span matListItemTitle>{{ sub.label }}</span>
                  </a>
                }
              </mat-nav-list>
           </div>
          }

        <mat-menu class="menu-sb-pane" overlapTrigger="true" #menu>
          @for (sub of item.submenu; track $index) {
              <button mat-menu-item [routerLink]="sub.route"  [hidden]="!checkRights([sub.right!])">{{ sub.label }}</button>
            }
        </mat-menu>
        }
      }
    </mat-nav-list>
  </mat-drawer>

  <div class="sidenav-content">
    <router-outlet></router-outlet>
  </div>

</mat-drawer-container>
